import { useMutation } from "react-query";

import { getProductPriceHistory } from "@/api/Maintainers/Products/products-query";
import { recalculateProductPrice, updateProductPrice } from "@/api/Maintainers/Products/products-mutation.js";

export function useProductPriceHistory() {
	return useMutation(getProductPriceHistory);
}

export function useUpdateProductPrice() {
	return useMutation(updateProductPrice);
}

export function useRecalculateProductPrice() {
	return useMutation(recalculateProductPrice);
}
